import { HttpClient, HttpHandlerFn, HttpHeaders, HttpRequest, HttpResponseBase } from "@angular/common/http";
import { Injector } from "@angular/core";
import { BehaviorSubject, catchError, filter, Observable, switchMap, take, tap, throwError } from "rxjs";
import { AuthService } from "../auth/auth.service";
import { Router } from "@angular/router";

let refreshToken = false;
let refreshToken$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

function reAttachToken(token, req: HttpRequest<any>): HttpRequest<any> {
  return req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function toLogin(injector: Injector) {
  injector
    .get(AuthService)
    .signOut()
    .subscribe(() => {
      // back to login
      setTimeout(() => injector.get(Router).navigateByUrl("/sign-in"));
    });
}

export function tryRefreshToken(injector: Injector, ev: HttpResponseBase, req: HttpRequest<any>, next: HttpHandlerFn): Observable<any> {
  const authService = injector.get(AuthService);

  if (!authService.refreshToken) {
    toLogin(injector);
    return throwError(() => ev);
  }
  if (refreshToken) {
    return refreshToken$.pipe(
      filter(token => token !== null),
      take(1),
      switchMap(token => next(reAttachToken(token, req)))
    );
  }
  refreshToken = true;
  refreshToken$.next(null);

  /**
   * This is a bandaid for an issue with the backend returning HTML instead of an OAuth response
   * TODO: Make this actually refresh tokens
   */
  toLogin(injector);
  return throwError(() => ev);
}
